import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  apiBaseUrl : string = environment.url;

  constructor(private _http : HttpClient) { }

  gettransactions(){
    return this._http.get(this.apiBaseUrl+'v1/transactions');
 }

//  deleteOfferById(quizId : string){
//   return this._http.delete(this.apiBaseUrl+'v1/quiz/'+quizId);
// }
}
